import { OnInit, OnDestroy, Optional, Inject, Component } from '@angular/core';
import { IContextService, DomainContext, IAuthorizationService, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-PerformanceReports',
    templateUrl: './dojo-PerformanceReports.component.html'
})
export class DojoPerformanceReportsComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    managedRestJson: any;
    isQprEnabled: boolean;
    stmtLink: string;
    isDprEnabled: boolean;
    dprRestUrl: string = '';
    entitledForDprReport: boolean;
    constructor(private contextService: IContextService,
                private router: Router,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private authorizationService: IAuthorizationService,
                private translationService: PershingTranslationService,  @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.stmtLink = '/nxi/communications/alldocuments/statementsreports';
        } else {
           this.stmtLink = '/nxi/communications/allcommunications/statementsreports';
        }
        this.entitledForDprReport = this.authorizationService.isEntitled('LOCKWOOD_DPRS_MNG_PERFORM');
        console.log('entitledForDprReport----->', this.entitledForDprReport);
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getLinksDisplay();
        });
    }

    ngOnDestroy(): void {
        console.log('In DojoPerformanceReportsComponent destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyPerformanceReports();
        }
    }
    renderDojoWidget(PerfReportParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderPerformanceReports(this.inputValue, PerfReportParams);
        }
    }

    getLinksDisplay() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiRestService.getNxiMAPerfRestResponse(this.acctRef, 'displayLinks').subscribe(
                 (respJson: Array<object>) => {
                    console.log('Retrived common REST Balances params : ', respJson);
                    this.managedRestJson = respJson;
                    this.isQprEnabled =  this.managedRestJson.qprEnabled;
                    this.isDprEnabled =  this.managedRestJson.dprEnabled;
                    this.renderDojoWidget(this.managedRestJson);
                }
            );
        }
    }

    openPdf() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.dprRestUrl = this.nxiRestService.getNxiDPRPerfRestUrl(this.acctRef, 'reports?reportType=DPR');
            window.open(this.dprRestUrl, 'mywindow', 'toolbar=no, scrollbars=no, menubar=no, status=no, location=no, resizable=yes, height=800, width=800');
        }
    }

    redirectRoute(url: string): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoParams' : {'viewId' : 'stmt'} ,
                'gotoPage': url
            }
        }));
    }
}
